<template lang="html">
  <div class="e2e-home page-submenu">
      <div class="e2e-container" style="display: flex;justify-content:space-between;">
          <div class="page-submenu_left">
            <div class="e2e-content-box">
                <left-bar tab='user-personal-center'></left-bar>
            </div>
          </div>
          <div class="page-submenu_right">
            <div class="e2e-content-box">
                <div class='user-container'>
                    <div class="user-basic-container" style="width: 400px">
                        <div class="e2e-form">
                            <div class="e2e-form-row">
                                <div class="e2e-form-group">
                                    <div class="e2e-form-label">
                                        {{$t('home.user_name')}}
                                    </div>
                                    <div class="e2e-form-item">
                                        <el-input
                                            v-model="userInfo.realname"
                                            clearable
                                            disabled
                                        >
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div class="e2e-form-row">
                                <div class="e2e-form-group">
                                    <div class="e2e-form-label">
                                        {{$t("home.user_role")}}
                                    </div>
                                    <div class="e2e-form-item">
                                        <el-input
                                            v-model="userInfo.roleNames"
                                            clearable
                                            disabled
                                        >
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div class="e2e-form-row">
                                <div class="e2e-form-group">
                                    <div class="e2e-form-label">
                                        {{$t("home.user_id")}}
                                    </div>
                                    <div class="e2e-form-item">
                                        <el-input
                                            v-model="userInfo.workerId"
                                            clearable
                                            disabled
                                        >
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div class="e2e-form-row">
                                <div class="e2e-form-group">
                                    <div class="e2e-form-label">
                                        {{$t('home.user_dept')}}
                                    </div>
                                    <div class="e2e-form-item">
                                        <el-input
                                            v-model="userInfo.departIdList"
                                            clearable
                                            disabled
                                        >
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div class="e2e-form-row">
                                <div class="e2e-form-group">
                                    <div class="e2e-form-label">
                                        {{$t('home.user_medical_field')}}
                                    </div>
                                    <div class="e2e-form-item">
                                        <el-input
                                            v-model="userInfo.medicalFieldList"
                                            clearable
                                            disabled
                                        >
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div class="e2e-form-row">
                                <div class="e2e-form-group">
                                    <div class="e2e-form-label">
                                        {{$t('home.user_email')}}
                                    </div>
                                    <div class="e2e-form-item">
                                        <el-input
                                            v-model="userInfo.email"
                                            clearable
                                            disabled
                                        >
                                        </el-input>
                                    </div>
                                </div>
                            </div>   
                        </div>
                    </div>                    
                </div>

            </div>
          </div>
      </div>
  </div>
</template>

<script>
import center from '@/api/user/center';
import LeftBar from '../LeftBar';
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';


export default {
  components: {
    LeftBar
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['basedataGetName','userInfo']),
  },
  methods: {
    ...mapActions(['initBaseDataByTypes']),
  },
  mounted() {  
  }
};
</script>

<style lang="less" scoped>
.user-container {
  padding: 48px 80px 56px;
  display: flex;

  .e2e-form-group {
    width: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?dc217af4